export default "__VITE_ASSET__BNWlXAs$__"